module.exports = __webpack_public_path__ + "static/babo-60181726b706fe24249da20f4cb51da0.gif";